import React, { Component } from "react";
import { connect } from "react-redux";
//
import Screen from "./ConnectedScreen";

class CountriesScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
    };
  }

  getCountries(query) {
    const { getCountries } = this.props;

    if (query.length > 1) {
      getCountries(query);
    }

    this.setState({
      value: query,
    });
  }

  setCountry(countryId) {
    const { goBack, setCountry } = this.props;

    setCountry(countryId);

    this.setState({
      value: "",
    });

    goBack();
  }

  render() {
    const { errorMessage, countries } = this.props;
    const { value } = this.state;

    return (
      <Screen title="Select phone country" isActive noFooter>
        <p>Enter your mobile's country code or name.</p>
        <div className="form__field">
          <input
            autoFocus
            type="text"
            placeholder="e.g. United or 44"
            value={value}
            className="form__control"
            onChange={(ev) => this.getCountries(ev.target.value)}
          />
        </div>
        <ol className="o-list-bare">
          {countries.map((country) => (
            <li
              key={country.id}
              className="suggestion"
              onClick={(ev) => this.setCountry(country.id)}
            >
              +{country.callingCode} {country.name}
            </li>
          ))}
        </ol>
        {errorMessage !== null && (
          <p className="u-danger u-small u-mt">{errorMessage}</p>
        )}
      </Screen>
    );
  }
}

// @connect
import { getCountriesAction, setCountryAction } from "../modules/countries";

function mapState(state) {
  const { countries } = state;

  return {
    countries: countries.result.map((id) => countries.entities[id]),
  };
}

function mapDispatch(dispatch) {
  return {
    getCountries(query) {
      dispatch(getCountriesAction(query));
    },
    setCountry(countryId) {
      dispatch(setCountryAction(countryId));
    },
  };
}

export default connect(mapState, mapDispatch)(CountriesScreen);
